import { render, staticRenderFns } from "./zsfa.vue?vue&type=template&id=f023b0bc&scoped=true"
import script from "./zsfa.vue?vue&type=script&lang=js"
export * from "./zsfa.vue?vue&type=script&lang=js"
import style0 from "./zsfa.vue?vue&type=style&index=0&id=f023b0bc&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f023b0bc",
  null
  
)

export default component.exports